import { createFileRoute } from "@tanstack/react-router";
import RolesConfiguration from "@/components/roles/roles-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/settings/_layout/roles")({
  component: RolesPage,
});

function RolesPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "roles", actions: ["read", "update"] }]}
    >
      <div>
        <div className="overflow-x-auto">
          <RolesConfiguration module="roles" />
        </div>
      </div>
    </RouteGuardPermissions>
  );
}
